import React from 'react';
import { AppstoreOutlined, FolderOutlined } from '@ant-design/icons';

import {
  buildingDisplayName,
  buildingsDisplayName,
} from '@totem/components/ui_components/constants';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import IBDIcon from '@totem/styles/Icon';
import { UserProfile } from '@totem/types/user';

export const getSubMenuPortfolio = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'portfolio',
      title: 'Overview',
      label: 'Overview',
      description: 'Overview Page',
      route: '/dashboard/portfolio',
      icon: <IBDIcon name="Portfolio" />,
      hasPermissions: () => {
        return permissions.collaborator.hasPermissions(userProfile);
      },
    },
    {
      key: 'dashboard',
      title: 'My Dashboard',
      label: 'My Dashboard',
      description: 'Customizable Dashboard',
      route: '/dashboard/home',
      icon: <IBDIcon name="Dashboard" />,
      hasPermissions: () => {
        return permissions.collaborator.hasPermissions(userProfile);
      },
    },
    {
      key: 'regions',
      title: 'Regions',
      label: 'Regions',
      description: 'Region Management',
      route: '/dashboard/regions',
      icon: <IBDIcon name="Region" />,
      hasPermissions: () => {
        return permissions.collaborator.hasPermissions(userProfile);
      },
    },
    {
      key: 'buildings',
      title: buildingsDisplayName,
      label: buildingsDisplayName,
      description: `${buildingDisplayName} Summary`,
      route: '/dashboard/buildings',
      icon: <IBDIcon name="Building" />,
      hasPermissions: () => {
        return permissions.collaborator.hasPermissions(userProfile);
      },
    },
    {
      key: 'controlSystems',
      title: 'Control Systems',
      label: 'Control Systems',
      description: 'Control System Summary',
      route: '/dashboard/controlSystemReport',
      icon: <IBDIcon name="Control System" />,
      hasPermissions: () => {
        return permissions.collaborator.hasPermissions(userProfile);
      },
    },
    {
      key: 'serviceMatrix',
      title: 'Service Matrix',
      label: 'Service Matrix',
      description: `Services by ${buildingDisplayName}`,
      route: '/dashboard/portfolio/serviceMatrix',
      icon: <AppstoreOutlined />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.internal.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'devices',
      title: 'Devices',
      label: 'Devices',
      description: 'Device Summary',
      route: '/dashboard/devices',
      icon: <IBDIcon name="Device" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.devices.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'org_software',
      title: 'Software',
      label: 'Software',
      description: 'Software Packages',
      route: '/dashboard/software/organization',
      icon: <IBDIcon name="Software" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.software.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'documents',
      title: 'Documents',
      label: 'Documents',
      description: 'Documents Library',
      route: '/dashboard/documents',
      icon: <FolderOutlined />,
      hasPermissions: () => {
        return permissions.collaborator.hasPermissions(userProfile);
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
